import { connect } from 'react-redux'
import ConfirmationUpdateRegister from '../components/ConfirmationUpdateRegister'


export default connect(null, null)(ConfirmationUpdateRegister)


// WEBPACK FOOTER //
// ./src/btoc/containers/ConfirmationUpdateRegisterContainer.js